function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as v } from "react/jsx-runtime";
import { BaseTouchable as g } from "./touchable.js";
import l from "classnames";
import { useTheme as p } from "./hooks.js";
import { useIsInverseVariant as k } from "./theme-variant-context.js";
import { useForm as d } from "./form-context.js";
import { getTextFromChildren as o } from "./utils/common.js";
import { useTrackingConfig as T, eventNames as x, eventCategories as I, eventActions as y } from "./utils/analytics.js";
import { variants as n } from "./text-link.css-mistica.js";
const E = (_param)=>{
    var { children: t , className: r = "" , disabled: a , style: s  } = _param, e = _object_without_properties(_param, [
        "children",
        "className",
        "disabled",
        "style"
    ]);
    const i = k(), { isDarkMode: m  } = p(), { formStatus: c  } = d(), { eventFormat: f  } = T(), u = ()=>f === "google-analytics-4" ? {
            name: x.userInteraction,
            component_type: "link",
            component_copy: o(t)
        } : {
            category: I.userInteraction,
            action: y.linkTapped,
            label: o(t)
        };
    var _e_trackingEvent;
    return /* @__PURE__ */ v(g, _object_spread_props(_object_spread({}, e), {
        stopPropagation: !0,
        as: e.onPress ? "a" : void 0,
        trackingEvent: (_e_trackingEvent = e.trackingEvent) !== null && _e_trackingEvent !== void 0 ? _e_trackingEvent : e.trackEvent ? u() : void 0,
        disabled: a || c === "sending",
        className: l(i ? m ? n.inverseDark : n.inverseLight : n.default, r),
        style: s,
        children: t
    }));
}, j = E;
export { j as default };
